// 테이블 컨테이너 스타일
export const tableContainerStyle = {
  border: '1px solid var(--Border-Default-2-Rest, #dbdbdb) !important',
  borderRadius: '8px !important',
};

// 셀 기본 스타일
export const cellStyle = {
  width: '100% !important',
  maxWidth: '100% !important',
  minWidth: 0,
  position: 'relative',
  display: 'block',
  padding: 'var(--Spacing-30, 8px) var(--Spacing-40, 12px)',
  color: 'var(--Text-Basic, #414141)',
  fontFamily: 'var(--Font-family-font, Pretendard)',
  fontSize: 'var(--Size-Body-X-Small, 13px)',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '150%',
  letterSpacing: '-0.13px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  boxSizing: 'border-box',
};

// 테이블 스타일
export const tableStyle = {
  tableLayout: 'fixed !important',
  width: '100% !important',
  '& .MuiTable-root': {
    borderCollapse: 'collapse',
    tableLayout: 'fixed !important',
    width: '100% !important',
  },
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'red !important',
    opacity: '1 !important',
    color: '#ffffff !important',
  },
  '& .MuiTooltip-popper .MuiTooltip-tooltip': {
    backgroundColor: 'red !important',
    opacity: '1 !important',
    color: '#ffffff !important',
  },
  '& .MuiTableCell-root': {
    border: 'none !important',
    borderTop: 'none !important',
    borderRight: 'none !important',
    borderBottom: 'none !important',
    borderLeft: 'none !important',
    outline: 'none !important',
    padding: '0 !important',
    overflow: 'hidden !important',
    tableLayout: 'fixed !important',
  },
  '& .MuiTableCell-root:not(:last-child)': {
    borderRight: 'none !important',
  },
  '& .MuiTableRow-root:not(:last-child) .MuiTableCell-root': {
    borderBottom: '1px solid var(--Divider-1, #F0F0F0) !important',
  },
  // body 셀 사이사이에 우측 선 추가 (마지막 셀 제외)
  '& .MuiTableBody-root .MuiTableCell-root:not(:last-child)': {
    borderRight: '1px solid var(--Divider-1, #F0F0F0) !important',
  },
  // body 셀 높이 설정
  '& .MuiTableBody-root .MuiTableCell-root': {
    height: '40px !important',
  },
  // body row hover 효과
  '& .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root': {
    background: 'var(--Surface-Default-1-Hover, #F8F8F8) !important',
  },
  // body row 클릭 효과
  '& .MuiTableBody-root .MuiTableRow-root:active .MuiTableCell-root': {
    background: 'var(--Surface-Default-1-Pressed, #E4E4E4) !important',
  },
  // 헤더 하단 선 추가
  '& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root': {
    borderBottom: '1px solid var(--Border-Default-1-Rest, #E4E4E4) !important',
    height: '36px !important',
  },
  // 헤더 셀 사이사이에 우측 선 추가 (마지막 셀 제외)
  '& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:not(:last-child)': {
    borderRight: '1px solid var(--Border-Default-1-Rest, #E4E4E4) !important',
  },
  // 첫 번째 행의 상단 선 제거 (외곽선과 겹침 방지)
  '& .MuiTableHead-root .MuiTableRow-root:first-of-type .MuiTableCell-root': {
    borderTop: 'none !important',
  },
  // 첫 번째 열의 좌측 선 제거 (외곽선과 겹침 방지)
  '& .MuiTableCell-root:first-of-type': {
    borderLeft: 'none !important',
  },
  // 마지막 행의 하단 선 제거 (외곽선과 겹침 방지)
  '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
    borderBottom: 'none !important',
  },
  // 마지막 열의 우측 선 제거 (외곽선과 겹침 방지)
  '& .MuiTableCell-root:last-child': {
    borderRight: 'none !important',
  },
  '& .MuiTableRow-root': {
    border: 'none !important',
  },
  '& .MuiTableHead-root': {
    border: 'none !important',
  },
  '& .MuiTableBody-root': {
    border: 'none !important',
  },
};

// 컬럼 정의 (UpdatePopup용) - 이름-사번-권한-부서-입사일-연락처-생년월일 순
export const COLUMNS = [
  {
    key: 'select',
    labelId: 'button.select',
    width: '40px',
    sortable: false,
  },
  {
    key: 'name',
    labelId: 'staff.create.basic.info.name',
    width: '240px',
    sortable: true,
  },
  {
    key: 'id',
    labelId: 'staff.list.id',
    width: '56px',
    sortable: true,
  },
  {
    key: 'role',
    labelId: 'staff.role',
    width: '114px',
    sortable: true,
  },
  {
    key: 'department',
    labelId: 'staff.create.basic.info.department',
    width: 'flex',
    sortable: true,
  },
  {
    key: 'dateEntered',
    labelId: 'staff.create.basic.info.date.entered',
    width: '110px',
    sortable: true,
  },
  {
    key: 'phone',
    labelId: 'staff.create.basic.info.phone',
    width: '130px',
    sortable: true,
  },
  {
    key: 'birth',
    labelId: 'staff.create.basic.info.birthday',
    width: '110px',
    sortable: true,
  },
];
